import { Dialog } from "@mui/material";
import { useEffect, useLayoutEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { isLoggedInVar, serviceId } from "../apollo";
import { TopBar } from "../components/topBar";
import cart from "../assets/icons/cart_white.svg";
import { useGetGood } from "../hooks/useGetGood";
import Snackbar from "@mui/material/Snackbar";
import Button from "@mui/material/Button";
import { useCrBaksetItem } from "../hooks/useCrBasketItem";
import { useDelBaksetItem } from "../hooks/useDelBasketItem";
import { useMe } from "../hooks/useME";
import { useListBaksetItem } from "../hooks/useListBaksetMine";
import { useCrReceipt } from "../hooks/useCrReceipt";
import { Thumbnails } from "../components/detail-Thumbnails";
import share from "../assets/icons/share.svg";
import React from "react";
import { useListGoodReview } from "../hooks/useListGoodReview";
import { useListGoodOption } from "../hooks/useListGoodOption";
import { AlertComponent, ConfirmComponent } from "../components/alert";
import {
  CrBasketItemInput,
  CrBasketItemMutation,
  CrReceiptInput,
  CrReceiptMutation,
  DelBasketItemMutation,
  DetailCrBasketInput,
  DetailCrReceiptInput,
  GetGoodInput,
  GetGoodQuery,
  GoodStatus,
  ListGoodOptionQuery,
  ListGoodReviewInput,
  ListGoodReviewQuery,
} from "../gql/graphql";
import { IGoodPosterItem } from "../constants/types";
import { useReactiveVar } from "@apollo/client";
import arrow_right from "../assets/icons/arrow_right.svg";
import { MinusIcon, PlusIcon } from "../components/Icons";
import { serviceIsActive } from "../apollo";
export interface State {
  open: boolean;
}

export const GoodDetail = () => {
  const params = useParams();
  const detail_serviceId = useReactiveVar(serviceId);
  const topbar_serviceIsActive = useReactiveVar(serviceIsActive);
  const [tab, setTab] = useState(0);
  const [OpenPhoto, setOpenPhoto] = React.useState(false);
  const [photo, setPhoto] = React.useState("");
  const { data: me } = useMe();
  const [scrollOver, setScrollOver] = useState<boolean>(false);
  const [basketIds, setBaksetIds] = useState<number[]>([Number(params.key)]);
  const [page, setPage] = useState<number>(1);
  const [selectName, setSelectName] = useState<string>("");
  const [boxOpen, setBoxOpen] = useState<boolean>(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertText, setAlertText] = useState<string | undefined>("");
  const [totalAmount, setTotalAmount] = useState<number>(0);
  // 다른 거래처 상품이 장바구니에 있을 때 교체 확인
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmText, setConfirmText] = useState<string | undefined>("");
  const [pendingBasketInput, setPendingBasketInput] =
    useState<CrBasketItemInput | null>(null);
  const [existingBasketItemIds, setExistingBasketItemIds] = useState<
    number[]
  >([]);
  const closeAlert = () => {
    setAlertOpen(false);
    if (alertText === "로그인이 필요합니다. <br/> 로그인 하시겠습니까?") {
      navigate("/login");
    } else if (alertText === "잘못된 경로입니다.") {
      navigate(-1);
    } else {
      setAlertOpen(false);
      setSlideUp(false);
    }
  };
  // 임시코드
  const [optionsIdxs, setOptionsIdxs] = useState<number[]>([]);
  // 임시코드 끝
  // snack bar
  const [state, setState] = useState<State>({
    open: false,
  });
  const { open } = state;

  const handleClick = () => {
    setState({ open: true });
  };

  const handleClose = () => {
    setState({ ...state, open: false });
  };
  const snacks = (
    <React.Fragment>
      <Button onClick={handleClose}>닫기</Button>
    </React.Fragment>
  );
  const onCompleted = (data: GetGoodQuery) => {
    const {
      getGood: { ok, good, err },
    } = data;
    if (ok && good) {
      listGoodReviewHandler(Number(good?.id));
    } else {
      setAlertText("잘못된 경로 입니다.");
      setAlertOpen(true);
    }
  };
  const navigate = useNavigate();
  const [getGood, { data }] = useGetGood(onCompleted);
  const [listBasketItem, { refetch }] = useListBaksetItem();

  const onCrReceipt = (data: CrReceiptMutation) => {
    const {
      crReceipt: { ok, receipt, err },
    } = data;
    console.log(data, "receipt");
    if (ok && receipt) {
      navigate(`/selectReceiveWays/${receipt.uuid}`, {
        state: {
          serviceId: detail_serviceId,
        },
      });
    } else {
      if (err) {
        setAlertText(err);
      } else {
        setAlertText("구매 진행에 실패했습니다");
      }
      setAlertOpen(true);
    }
  };
  const [crReceipt, { loading: crReceiptLoading }] = useCrReceipt(onCrReceipt);

  const crReceiptHandler = () => {
    console.log(optionsSelected, "optionsSelected");
    if (!optionsSelected) {
      alert("상품을 선택해주세요");
      return;
    }
    if (!crReceiptLoading) {
      const goodId = data?.getGood.good?.id;
      var buyInfos: DetailCrReceiptInput[] = [];
      var info: DetailCrReceiptInput = {
        goodId,
        goodOptionId: optionsSelected?.goodOptionId || null,
        quantity: optionsSelected?.quantity || 1,
      };
      console.log(info, "info");
      buyInfos.push(info);
      const input: CrReceiptInput = {
        buyInfos,
      };
      crReceipt({
        variables: { input },
        // 캐시 업데이트 정책
        fetchPolicy: "no-cache", // 캐시 충돌 방지
        errorPolicy: "all",
      });
    }
  };
  // list review
  const onListReview = (data: ListGoodReviewQuery) => {
    const {
      listGoodReview: { ok, err, goodReviews },
    } = data;
    if (ok && goodReviews) {
    }
  };
  const [
    ilstGoodReview,
    { data: listGoodReviewData, loading: listReviewLoading },
  ] = useListGoodReview(onListReview);
  const listGoodReviewHandler = (goodId: number) => {
    const input: ListGoodReviewInput = {
      goodId: goodId,
    };
    ilstGoodReview({ variables: { input } });
  };

  //  copy url
  const CopyUrlToClipboard = () => {
    var dummy = document.createElement("input");
    var text = window.location.href;

    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    handleClick();
  };

  useLayoutEffect(() => {
    if (!Number(params.key)) {
      setAlertText("잘못된 경로 입니다.");
      setAlertOpen(true);
    }
    const getGoodInput: GetGoodInput = {
      goodId: Number(params.key),
    };
    getGood({ variables: { input: getGoodInput } });
    var el = document.querySelector(".scroll-smooth");
    el?.addEventListener("scroll", () => {
      if (el?.scrollTop && el?.scrollTop > 100) {
        setScrollOver(true);
      } else {
        setScrollOver(false);
      }
    });
  }, []);

  // 옵션 선택 구매
  interface optionSelected {
    name?: string;
    price?: number;
    discountRate?: number;
    goodOptionId?: number;
    quantity?: number;
  }
  const [slideUp, setSlideUp] = useState<boolean>(false);
  const [optionsSelected, setOptionsSelected] = useState<optionSelected>();
  // const limitOrderNumHandler = () => {
  //   var sum = optionsSelected?.quantity || 1;
  //   if (
  //     Number(data?.getGood.good?.limitNumOrders) > 0 &&
  //     sum > Number(data?.getGood.good?.limitNumOrders)
  //   ) {
  //     setAlertText(
  //       `최대 주문가능 수량은 ${Number(
  //         data?.getGood.good?.limitNumOrders
  //       )}개 입니다.`
  //     );
  //     setAlertOpen(true);

  //     return false;
    
  //   } else {
  //     return true;
  //   }
  // };
  const optionsSelectedHandler = (
    value: any,
    name: string,
    price: number | null,
    discountRate: number | null
  ) => {
    var index;
    if (!Number(value)) {
      index = optionsSelected?.goodOptionId;
    } else {
      index = optionsSelected?.goodOptionId;
    }
    if (!index) {
      var newInput: optionSelected = {
        name: name,
        goodOptionId: Number(value),
        quantity: 1,
        price: price ? price : undefined,
        discountRate: discountRate ? discountRate : 0,
      };
      setOptionsSelected(newInput);
    }
  };
  // const optionsSelectedQuantityHandler = (
  //   goodOptionName: string,
  //   cal: boolean
  // ) => {
  //   var newOptions: optionSelected[];
  //   if (cal) {
  //     if (!limitOrderNumHandler()) {
  //       return;
  //     }
  //     setOptionsSelected({
  //       ...optionsSelected,
  //       quantity: Number(optionsSelected?.quantity) + 1,
  //     });
  //   } else {
  //     setOptionsSelected({
  //       ...optionsSelected,
  //       quantity: Number(optionsSelected?.quantity) - 1,
  //     });
  //   }
  // };

  const totalPriceCalculater = () => {
    var total: number = 0;
    var unitPrice = Number(data?.getGood.good?.price);
    total = total + Number(optionsSelected?.quantity) * unitPrice;
    return total;
  };

  const onListGoodOption = (data: ListGoodOptionQuery) => {
    const {
      listGoodOption: { ok, err, goodOptions },
    } = data;
    if (ok && goodOptions) {
      console.log(goodOptions);
      setSelectOption(goodOptions[0].id + "");
      setOptionsSelected({
        name: goodOptions[0].name || "",
        goodOptionId: goodOptions[0].id,
        quantity: 1,
        price: goodOptions[0].price || 0,
        discountRate: goodOptions[0].discountRate || 0,
      });
    } else {
      alert(err);
    }
  };
  const [listGoodOption, { data: listGoodOptionData }] =
    useListGoodOption(onListGoodOption);
  const listOptionsHandler = (goodId: number) => {
    listGoodOption({ variables: { input: { goodId } } });
  };

  // 옵션 선택 장바구니
  const onMakeBasketItem = async (data: CrBasketItemMutation) => {
    const {
      crBasketItem: { ok, err },
    } = data;
    if (ok) {
      await refetch();
      setAlertText("장바구니에 추가 되었습니다.");
      setAlertOpen(true);
      // alert("장바구니에 추가 되었습니다.");
    } else {
      console.log(err);
      if (err) {
        setAlertText(err);
      } else {
        setAlertText("이미 장바구니에 추가 되어있습니다.");
      }

      setAlertOpen(true);
    }
  };
  const [crBasketItem] = useCrBaksetItem(onMakeBasketItem);

  // 다른 거래처 상품으로 교체 확인 후 처리
  const closeConfirm = () => {
    setConfirmOpen(false);
    setPendingBasketInput(null);
    setExistingBasketItemIds([]);
  };
  const onDelBasketItem = (data: DelBasketItemMutation) => {
    const {
      delBasketItem: { ok, err },
    } = data;
    if (ok && pendingBasketInput) {
      crBasketItem({ variables: { input: pendingBasketInput } });
    } else {
      setAlertText(err ? err : "장바구니를 비우는 중 문제가 발생했습니다.");
      setAlertOpen(true);
    }
    setConfirmOpen(false);
    setPendingBasketInput(null);
    setExistingBasketItemIds([]);
  };
  const [delBasketItem] = useDelBaksetItem(onDelBasketItem);
  const confirmReplaceBasket = () => {
    if (existingBasketItemIds.length > 0) {
      delBasketItem({
        variables: { input: { basketItemIds: existingBasketItemIds } },
      });
    }
  };

  const crBasketItemHandler = async () => {
    if (!optionsSelected) {
      alert("상품을 선택해주세요.");
      return;
    }
    if (!crReceiptLoading) {
      const goodId = data?.getGood.good?.id;
      var basketInfos: DetailCrBasketInput[] = [];
      var info: DetailCrBasketInput = {
        goodId,
        goodOptionId: optionsSelected?.goodOptionId
          ? optionsSelected?.goodOptionId
          : null,
        quantity: optionsSelected?.quantity,
      };
      basketInfos.push(info);
      const input: CrBasketItemInput = {
        basketInfos,
      };

      // 장바구니에는 동일한 거래처 상품만 담을 수 있도록, 담기 전에 기존 장바구니를 확인한다.
      const currentCorporationId = data?.getGood.good?.corporation?.id;
      const { data: basketData } = await listBasketItem();
      const existingItems = basketData?.listBasketItem?.basketItems;
      const otherCorporationItem = existingItems?.find(
        (item) => item.good?.corporation?.id !== currentCorporationId
      );
      if (currentCorporationId && otherCorporationItem) {
        setExistingBasketItemIds(
          (existingItems ?? []).map((item) => item.id)
        );
        setPendingBasketInput(input);
        setConfirmText(
          `장바구니에는 <b>${otherCorporationItem.good?.corporation?.name}</b>의 상품만 담겨있어요.<br/>기존 장바구니를 비우고 새 상품을 담으시겠습니까?`
        );
        setConfirmOpen(true);
        return;
      }

      crBasketItem({ variables: { input } });
    }
  };

  // 옵션 선택 체크
  const [selectOption, setSelectOption] = useState<string>("");

  // 옵션 리스트
  useEffect(() => {
    if (!me) {
      setAlertText("로그인이 필요합니다. <br/> 로그인 하시겠습니까?");
      setAlertOpen(true);
      return;
    }
    if (Number(params.key)) {
      listOptionsHandler(Number(params.key));
    }
  }, [params.key]);

  return (
    <div
      className={`wrap max-w-screen-break mx-auto w-full h-full overflow-auto removeScroll scroll-smooth `}
    >
      <div
        className={`header absolute top-0 left-0 w-full z-20 transition ${
          scrollOver ? "bg-white shadow" : "transparent"
        } `}
      >
        <div>
          <TopBar
            arrow={true}
            home={true}
            shop={true}
            shopColor={"mainIcon"}
            backColor={"transparent"}
            homeColor={"#00b0eb"}
            arrowColor={"#00b0eb"}
          />
        </div>
      </div>
      <main className="max-w-screen-break relative z-10">
        <div className="headInfo">
          <div className="imgBox relative max-w-screen-fit mx-auto ">
            <Thumbnails
              posters={data?.getGood?.good?.goodPosters as IGoodPosterItem[]}
            ></Thumbnails>
          </div>
          <div className="infoBox relative pt-4 max-w-screen-fit mx-auto">
            {/* <div className="absolute -top-8 left-1/2 transfrom -translate-x-1/2 w-16 h-16 bg-block2 rounded-full flex flex-wrap content-center justify-center">
              <img
                src={food && food.brandImg}
                alt={food && food.brand + "로고 이미지"}
                className="w-12 h-12"
              />
            </div> */}
            <div className="px-4">
              <div className="text-[13px] leading-4 text-[#60B0DB]  flex flex-wrap justify-between">
                <p className="pb-2">
                  <span className="">
                    {data?.getGood.good?.corporation &&
                      data?.getGood.good?.corporation?.name}
                  </span>
                </p>
                <button onClick={CopyUrlToClipboard}>
                  <img src={share} alt="공유하기" />
                </button>
              </div>
              <p className="font-medium text-[16px] leading-4 my-1 ellipsis1">
                {data?.getGood.good?.title && data?.getGood.good?.title}
              </p>

              <div className="py-4">
                <p className="max-h-12 text-standard text-grayFont ellipsis2 overflow-hidden">
                  {data?.getGood.good?.summary}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="bodyInfo pb-[100px] border-hintFont">
          <div id="detail" className="pb-4">
            {/* 옵션 */}
            <div id="options" className="border-t-8 border-bg DeailOptions p-4">
              <p className="font-bold pb-2">가격 (옵션)</p>
              <div className=" pt-2 flex flex-col gap-y-2">
                {/* 옵션들  map */}
                {listGoodOptionData?.listGoodOption.goodOptions?.map(
                  (option, index) => (
                    <div
                      key={`option-${option.id}-${index}`}
                      className="options flex flex-wrap gap-x-2"
                    >
                      <div className="flex-1 ">
                        <input
                          type="radio"
                          name="goodOption"
                          id={option.id + ""}
                          checked={selectOption == option.id + ""}
                          onChange={(e) => {
                            setSelectOption(option.id + "");
                            setOptionsSelected({
                              ...optionsSelected,
                              goodOptionId: option.id,
                              name: option.name || "",
                              price: option.price || undefined,
                              discountRate: option.discountRate || undefined,
                            });
                          }}
                          className="mr-2 hidden"
                        />
                        <label
                          htmlFor={
                            option.id ? option.id + "" : "goodOption" + index
                          }
                          className="flex items-center gap-x-2"
                        >
                          <div>
                            <div className="w-4 h-4 border border-mainIcon rounded-full relative">
                              {selectOption == option.id + "" && (
                                <div className="w-2 h-2 bg-mainIcon rounded-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"></div>
                              )}
                            </div>
                          </div>
                          <p className="text-sm">{option.name}</p>
                        </label>
                      </div>
                      <div className="w-24 text-right">
                        <p className="text-base font-bold">
                          {option.price ? option.price : 0} 원
                        </p>
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
            {/* 수량 */}
            <div className="px-4 border-t-8 border-bg py-4 countBox">
              <div className="flex gap-x-2 justify-between items-center">
                <p className="text-lg font-bold">수량</p>
                <div className="border rounded-md flex items-center gap-x-4">
                  <button
                    onClick={() => {
                      if (
                        optionsSelected?.quantity &&
                        optionsSelected?.quantity > 1
                      ) {
                        setOptionsSelected({
                          ...optionsSelected,
                          quantity: optionsSelected?.quantity - 1,
                        });
                      } else {
                        setAlertText("최소 주문 수량은 1개 입니다.");
                        setAlertOpen(true);
                      }
                    }}
                    className="h-full px-2"
                  >
                    <MinusIcon />
                  </button>
                  <p className="text-lg flex-1 py-1">
                    {optionsSelected?.quantity} 개
                  </p>
                  <button
                    onClick={() => {
                      const selectedGoodOption =
                        data?.getGood.good?.goodOptions?.find(
                          (option) =>
                            option.id === optionsSelected?.goodOptionId
                        );
                      // 옵션에 판매 수량제한(count)이 설정된 경우에만 제한을 건다.
                      // count가 null/undefined(제한 없음)이면 무제한으로 담을 수 있어야 한다.
                      const optionLimit =
                        selectedGoodOption?.count === null ||
                        selectedGoodOption?.count === undefined
                          ? null
                          : Number(selectedGoodOption.count);

                      if (
                        Number(data?.getGood.good?.limitNumOrders) > 0 &&
                        optionsSelected?.quantity &&
                        optionsSelected?.quantity >=
                          Number(data?.getGood.good?.limitNumOrders)
                      ) {
                        setAlertText(
                          `최대 주문가능 수량은 ${Number(
                            data?.getGood.good?.limitNumOrders
                          )}개 입니다.`
                        );
                        setAlertOpen(true);
                      }
                      else if (
                        optionLimit !== null &&
                        optionsSelected?.quantity &&
                        optionsSelected?.quantity >= optionLimit
                      ) {
                        setAlertText(
                          `선택하신 옵션의 최대 주문가능 수량은 ${optionLimit}개 입니다.`
                        );
                        setAlertOpen(true);
                      }
                      else {
                        setOptionsSelected({
                          ...optionsSelected,
                          quantity: (optionsSelected?.quantity || 0) + 1,
                        });
                      }
                    }}
                    className="h-full px-2"
                  >
                    <PlusIcon />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div id="inquiry" className="px-4 py-5 bg-bg">
            <div className="text-sm py-2">
              <p>
                메뉴 사진은 연출된 이미지로 실제 조리된 음식과 다를 수 있습니다.
              </p>
            </div>
            <div className="text-sm">
              <p>배달이나 음식에 대한 의견이 있다면 언제든지 문의해주세요.</p>
              <button
                onClick={() => {
                  if (!isLoggedInVar()) {
                    setAlertText(
                      "로그인이 필요합니다. <br/> 로그인 하시겠습니까?"
                    );
                    setAlertOpen(true);
                  } else {
                    navigate("/mypage/enrollInquiry");
                  }
                }}
                className="py-2  text-grayFont font-bold flex "
              >
                문의하러가기
                <img
                  src={arrow_right}
                  alt="문의하러가기"
                  className="w-4 ml-2 inline-block"
                />
              </button>
            </div>
          </div>
        </div>
      </main>
      <div className="absolute bottom-0 left-0 w-full z-10">
        <div className="break:sticky absolute  bottom-0 left-1/2 transform -translate-x-1/2 break:transform break:translate-x-0  w-full flex flex-wrap h-[72px]">
          <button
            onClick={() => {
              if (!me?.me.id) {
                setAlertText("로그인이 필요합니다. <br/> 로그인 하시겠습니까?");
                setAlertOpen(true);
              } else {
                if (data?.getGood.good?.status === GoodStatus.GoodReady) {
                  setAlertText("판매중인 상품이 아닙니다.");
                  setAlertOpen(true);
                } else {
                  crBasketItemHandler();
                }
              }
            }}
            className="w-[72px] h-full bg-hintFont"
          >
            <img src={cart} alt="장바구니 담기" className="inline w-10" />
          </button>

          {topbar_serviceIsActive === true &&
            data?.getGood.good?.corporation?.isActive === true && (
              <button
                onClick={() => {
                  if (!me?.me.id) {
                    setAlertText(
                      "로그인이 필요합니다. <br/> 로그인 하시겠습니까?"
                    );
                    setAlertOpen(true);
                  } else {
                    if (data?.getGood.good?.status === GoodStatus.GoodReady) {
                      setAlertText("판매중인 상품이 아닙니다.");
                      setAlertOpen(true);
                    } else {
                      crReceiptHandler();
                    }
                  }
                }}
                className="h-full flex-1 bg-mainIcon text-white text-standard break:text-large font-bold"
              >
                구매하기
              </button>
            )}

          {/* off 일때  */}
          {topbar_serviceIsActive === false && (
            <button className="h-full flex-1 bg-[#D9D9D9] text-white text-standard break:text-large font-bold">
              이 지역은 지금 서비스하고 있지 않아요.
            </button>
          )}
          {data?.getGood.good?.corporation?.isActive === false && (
            <button className="h-full flex-1 bg-[#D9D9D9] text-white text-standard break:text-large font-bold">
              매장이 준비중이에요.
            </button>
          )}
        </div>
      </div>

      <Dialog open={alertOpen} className="relative">
        <AlertComponent
          title={`알림`}
          desc={alertText}
          closeFunction={closeAlert}
        ></AlertComponent>
      </Dialog>
      <Dialog open={confirmOpen} className="relative">
        <ConfirmComponent
          title={`알림`}
          desc={confirmText}
          closeFunction={closeConfirm}
          confirmFunction={confirmReplaceBasket}
        ></ConfirmComponent>
      </Dialog>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        onClose={handleClose}
        message={"클립보드에 URL이 복사되었습니다."}
        action={snacks}
      ></Snackbar>
      <Dialog
        open={OpenPhoto}
        onClose={() => {
          setOpenPhoto(false);
        }}
      >
        <div className="w-full max-w-[320px] px-2 transform">
          <img
            src={photo}
            alt="사진 확대"
            className="w-full h-full object-fill"
          />
        </div>
      </Dialog>
    </div>
  );
};
